import React, { cloneElement } from 'react';
import Type from 'prop-types';
import { noop } from 'lodash';
import { Badge, IconButton, Autocomplete } from '@mui/material';
import { Clear as ClearIcon, Tune as TuneIcon } from '@mui/icons-material';
import { useTranslation } from 'hooks';
import SearchField from '../../Form/SearchField';
import styles from './SearchDialog.module.css';

const SearchDialog = (props) => {
  const {
    SearchInputProps,
    loading,
    value,
    classes,
    onChange,
    inputValue,
    onInputChange,
    onSubmit,
    blurOnSelect,
    ...autocompleteProps
  } = props;
  const { t } = useTranslation();

  const handleSubmit = (event) => {
    event.preventDefault();

    onSubmit(event);
  };

  return (
    <Autocomplete
      value={value}
      onChange={onChange}
      inputValue={inputValue}
      onInputChange={onInputChange}
      loading={loading}
      loadingText={t('loading')}
      blurOnSelect={blurOnSelect}
      classes={{
        hasClearIcon: styles.hasClearIcon,
        inputRoot: styles.inputRoot,
        paper: styles.paper,
        ...classes,
      }}
      forcePopupIcon={false}
      closeIcon={<ClearIcon />}
      renderInput={(params) => {
        const { InputProps, InputLabelProps, ...otherParams } = params;
        const { startAdornment, ...otherInputProps } = InputProps;
        const {
          filterIcon = <TuneIcon />,
          filtersCount,
          onFiltersClick,
          ...otherSearchInputProps
        } = SearchInputProps;

        const FilterAction = (
          <IconButton key="filterButton" size="small" onClick={onFiltersClick}>
            {filterIcon}
          </IconButton>
        );

        let filterButton = null;

        if (filterIcon) {
          filterButton =
            filtersCount === 0 ? (
              FilterAction
            ) : (
              <Badge key="filters" color="primary" badgeContent={filtersCount}>
                {FilterAction}
              </Badge>
            );
        }

        const endAdornment = InputProps.endAdornment
          ? cloneElement(
              InputProps.endAdornment,
              {},
              ...React.Children.toArray(InputProps.endAdornment.props.children),
              filterButton,
            )
          : filterButton;

        return (
          <SearchField
            fullWidth
            loading={loading}
            Component="form"
            action="#"
            type="search"
            onSubmit={handleSubmit}
            {...otherInputProps}
            {...otherParams}
            endAdornment={endAdornment}
            {...otherSearchInputProps}
          />
        );
      }}
      {...autocompleteProps}
    />
  );
};

SearchDialog.propTypes = {
  value: Type.any, // eslint-disable-line react/forbid-prop-types,
  onChange: Type.func.isRequired,
  inputValue: Type.oneOfType([Type.string, Type.number]).isRequired,
  onInputChange: Type.func.isRequired,
  loading: Type.bool,
  blurOnSelect: Type.bool,
  classes: Type.shape({
    hasClearIcon: Type.string,
  }),
  SearchInputProps: Type.shape({
    filterIcon: Type.node,
    filtersCount: Type.number,
    onFiltersClick: Type.func,
    onBackClick: Type.func,
    visible: Type.bool.isRequired,
    fullWidth: Type.bool,
    loading: Type.bool,
  }),
  onSubmit: Type.func,
};

SearchDialog.defaultProps = {
  value: null,
  SearchInputProps: {},
  classes: {},
  loading: false,
  blurOnSelect: false,
  onSubmit: noop,
};

export default SearchDialog;
